export const createDashboardSlice = (set) => ({
  statsData: {},
  setStatsData: (data) => set({ statsData: data }),
  hideLicense: true,
});
